import { dictionary } from '../../engine/dictionary';
import type { PuzzleMode } from '../../engine/types';
import { CipherBoard } from './Board';
import {
  CIPHER_DIFFICULTIES,
  deserialize,
  generate,
  handleKey,
  hint,
  reduce,
  score,
  status,
  summarize,
  validateMove,
  type CipherConfig,
  type CipherMove,
  type CipherState,
} from './logic';

export const cipherMode: PuzzleMode<CipherState, CipherMove, CipherConfig> = {
  id: 'cipher',
  name: 'Cipher',
  tagline: 'Crack the hidden word',
  description:
    'Guess the secret word. Each guess reveals which letters are right, which are misplaced, and which are absent.',
  accent: 'vine',
  glyph: 'cipher',
  howToPlay: [
    { title: 'Make a guess', body: 'Type any valid word of the right length and press Enter.' },
    {
      title: 'Read the clues',
      body: 'Green = right letter, right spot. Amber = right letter, wrong spot. Grey = not in the word.',
    },
    { title: 'Close in', body: 'Use every clue to deduce the answer before your guesses run out.' },
  ],
  difficulties: CIPHER_DIFFICULTIES,
  defaultDifficultyId: 'standard',
  generate,
  reduce,
  status,
  validateMove: (state, move) => {
    const base = validateMove(state, move);
    if (!base.ok) return base;
    if (move.type === 'submit' && !dictionary.isValid(state.current)) {
      return { ok: false, reason: 'Not in word list' };
    }
    return { ok: true };
  },
  handleKey,
  hint,
  score,
  summarize,
  serialize: (state) => state,
  deserialize,
  Board: CipherBoard,
};
